import * as yup from 'yup';

const paymentTypes = [
  "visaDomesticCredit",
  "visaDomesticDebit",
  "visaInternational",
  "mastercardDomesticCredit",
  "mastercardDomesticDebit",
  "mastercardInternational",
  "eftposAustralia",
  "discoverDiners",
  "amex",
  "upi",
  "jcb"
];

const mdrDefaultModel = {
  settlementType: '',
  ...paymentTypes.reduce((acc, type) => ({
    ...acc,
    [`${type}_msf_rate`]: "0",
    [`${type}_msf_value`]: "0.00",
    [`${type}_mdrType`]: "Blended"
  }), {})
};

const mdrDefaultSchema = yup.object().shape({
  settlementType: yup
    .string()
    .required('Settlement Type is required'),
  
  ...paymentTypes.reduce((acc, type) => ({
    ...acc,
    [`${type}_msf_rate`]: yup
      .string()
      .matches(/^[0-9]+(\.[0-9]{1,2})?$/, 'Must be a valid number with up to 2 decimal places')
      .required('MSF Rate is required'),
    [`${type}_msf_value`]: yup
      .string()
      .matches(/^[0-9]+(\.[0-9]{2})?$/, 'Must be a valid number with exactly 2 decimal places')
      .required('Fee is required'),
    [`${type}_mdrType`]: yup
      .string()
      .required('MDR Type is required')
  }), {})
});

export { mdrDefaultModel, mdrDefaultSchema };